module.exports = __webpack_public_path__ + "img/symbol_arrow1red.5ba2be3c.png";